import React, { useState } from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import Header from '../../components/reusableComponents/Header';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import MyProfileForm from '../../components/reusableComponents/MyProfileForm';
import ChangePasswordForm from '../../components/reusableComponents/ChangePasswordForm';
import DashboardTable from '../../components/reusableComponents/DashboardTable';
import DashboardTable2 from '../../components/reusableComponents/DashboardTable2';
import ManageMarkupForm from '../../components/reusableComponents/ManageMarkupForm';
import BankDetails from '../../components/reusableComponents/BankDetails';
import Overview from '../../components/reusableComponents/Overview';
import { useHistory } from 'react-router-dom';
import { travellerloginSuccess } from '../../reducers/UserReducer';
import { useDispatch } from 'react-redux';
const tableHeaders = [
	'Type',
	'Order ID',
	'Depart From',
	'Journey To',
	'Order Date',
	'Journey Date',
	'Ticket Cost',
	'Status',
	'Details',
];
const tableHeaders2 = [
	'Type',
	'Transaction Date',
	'Transaction Amount',
	// 'Description',
	'Commission',
	'Markup',
	'Payment Type',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,
		color: '#8C8C8C',
		padding: 3,
		fontSize: 12,
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);

const Dashboard = () => {
	const [data, setData] = useState('');
	const dispatch = useDispatch();
	const history = useHistory();
	return (
		<>
			<Header />
			<Container style={{ marginTop: 100 }}>
				<Grid container spacing={4}>
					<Grid item xs={3}>
						<Box
							style={{
								// border: '1px solid #e6e6e6',
								background: '#4d4d4d',
								borderRadius: '5px',
								marginRight: '30px',
								padding: '20px 0',
								// background: #4d4d4d;
								color: '#fff',
								marginBottom: '30px',
								// boxShadow: 'rgb(3 98 175 / 10%) 5px 5px 30px',
							}}>
							{/* <Box
								style={{
									padding: 10,
									height: '100px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
								}}> */}
							{/* <Avatar>H</Avatar> */}
							<Box textAlign='center'>
								<TitleText three>RIYA VERMA</TitleText>
								<Box display='flex' textAlign='center' justifyContent='center'>
									<BodyText two>Agent ID:</BodyText>
									<BodyText two>MFBAGB2B3047</BodyText>
								</Box>
								<BodyText two>Agent Since 04 Oct 2021</BodyText>
							</Box>
							{/* </Box> */}
							<Box
								mt={'10px'}
								onClick={() => setData('dashboard')}
								style={{
									backgroundColor:
										data === 'dashboard' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'dashboard'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Dashboard</TitleText>
							</Box>
							<Box
								onClick={() => setData('overview')}
								style={{
									backgroundColor:
										data === 'overview' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'overview'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Overview</TitleText>
							</Box>
							<Box
								onClick={() => setData('edit')}
								style={{
									backgroundColor: data === 'edit' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'edit'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Edit Profile</TitleText>
							</Box>
							<Box
								onClick={() => setData('booking')}
								style={{
									backgroundColor:
										data === 'booking' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'booking'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Booking History</TitleText>
							</Box>
							<Box
								onClick={() => setData('password')}
								style={{
									backgroundColor:
										data === 'password' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'password'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Change Password</TitleText>
							</Box>
							<Box
								onClick={() => setData('markup')}
								style={{
									backgroundColor:
										data === 'markup' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'markup'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Manage Markup</TitleText>
							</Box>
							<Box
								style={{
									border: '1px solid #e6e6e6',
									// backgroundColor: 'rgb(57, 201, 187)',
									color: 'black',
									padding: 10,
								}}>
								<TitleText two>Cancellation History</TitleText>
							</Box>
							<Box
								onClick={() => setData('bank')}
								style={{
									backgroundColor: data === 'bank' ? 'rgb(222, 246, 244)' : '',
									color: 'black',
									padding: 10,
									border:
										data == 'bank'
											? '1px solid rgb(57, 201, 187)'
											: '1px solid #e6e6e6',
								}}>
								<TitleText two>Bank Details</TitleText>
							</Box>

							<Box
								onClick={() => {
									dispatch(travellerloginSuccess(null));
									localStorage.clear();
									history.push('/');
								}}
								style={{
									border: '1px solid #e6e6e6',
									// backgroundColor: 'rgb(57, 201, 187)',
									color: 'black',
									padding: 10,
									cursor: 'pointer',
								}}>
								{/* <TitleText two>Logout</TitleText> */}
							</Box>
						</Box>
					</Grid>
					<Grid item xs={8}>
						{data === 'dashboard' && (
							<>
								<Grid container spacing={2}>
									<Grid item sm={12} md={12} lg={8}>
										<Grid container spacing={2}>
											{[0, 1, 2, 3].map((i, index) => {
												return (
													<>
														<Grid item sm={4} md={3} lg={3}>
															<Paper
																component={Box}
																elevation={0}
																borderRadius={15}
																boxShadow='5px 5px 30px rgba(3, 98, 175, 0.1)'
																style={{
																	// padding: 9,
																	display: 'flex',
																	alignItems: 'center',
																}}>
																<Box
																	// ml={'10px'}
																	mt={'3px'}
																	style={{
																		borderRadius: 15,
																		padding: 15,
																		// overflow: 'hidden',
																		boxShadow:
																			'5px 5px 30px rgba(3, 98, 175, 0.1)',
																	}}>
																	<BodyText
																		one
																		textStyle={{
																			color: '#00325B',
																			fontWeight: 600,
																			whiteSpace: 'nowrap',
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																		}}>
																		{index == 0
																			? 'Total Booking'
																			: index == 1
																			? 'Total Transaction'
																			: index == 2
																			? 'Cancel Booking'
																			: 'Total Booking'}
																	</BodyText>
																	<TitleText
																		three
																		textStyle={{
																			color: '#00325B',
																			textAlign: 'center',
																		}}>
																		5
																	</TitleText>
																</Box>
															</Paper>
														</Grid>
													</>
												);
											})}
										</Grid>
										<Grid container>
											<Grid
												item
												xs={12}
												style={{
													boxShadow: '5px 5px 30px rgba(3, 98, 175, 0.1)',
													borderRadius: 15,
													marginTop: 20,
													backgroundColor: 'white',
													padding: 15,
												}}>
												<Box display='flex' justifyContent='space-between'>
													<BodyText
														two
														textStyle={{
															fontWeight: 700,
															color: '#00325B',
															opacity: 0.45,
														}}>
														Transaction History
													</BodyText>
													<Box display='flex' alignItems='center'>
														<Box
														// onClick={() => {
														// 	history.push('/appointments');
														// 	dispatch(setCurrentMenu('appointments'));
														// 	dispatch(setCurrentSubMenu(''));
														// }}
														>
															<BodyText
																one
																textStyle={{
																	fontWeight: 600,
																	cursor: 'pointer',
																}}>
																View All{' '}
																<Divider
																	style={{ backgroundColor: '#00325B' }}
																/>
															</BodyText>
														</Box>
													</Box>
												</Box>
												<TableContainer style={{ marginTop: 15 }}>
													<Table>
														<TableHead>
															<TableRow>
																{tableHeaders2.map((title, index) => (
																	<StyledTableCell key={title}>
																		{title}
																	</StyledTableCell>
																))}
															</TableRow>
														</TableHead>
														<TableBody>
															{/* {appnt.map((item, rowIndex) => {
												return (
													<DashboardAppointment item={item} index={rowIndex} />
												);
											})} */}
															{[0, 1, 2].map((i, index) => {
																return <DashboardTable2 rowIndex={index} />;
															})}
														</TableBody>
													</Table>
												</TableContainer>
											</Grid>
										</Grid>
									</Grid>
									<Grid item sm={12} md={12} lg={4}>
										<Grid container style={{ height: '100%' }}>
											<Grid
												item
												xs={12}
												style={{
													boxShadow: '5px 5px 30px rgba(3, 98, 175, 0.1)',
													borderRadius: 15,
													padding: 12,
													backgroundColor: 'white',
												}}>
												<Box
													mt={'30px'}
													display='flex'
													justifyContent='center'
													alignItems='center'>
													<TitleText textStyle={{ fontSize: 25 }}>
														TOTAL AMOUNT
													</TitleText>
												</Box>
												<Box
													mt={'63px'}
													display='flex'
													justifyContent='center'
													alignItems='center'>
													<TitleText textStyle={{ fontSize: 30, color: 'red' }}>
														INR 2500.00
													</TitleText>
												</Box>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<Grid container spacing={2}>
									<Grid
										item
										xs={12}
										style={{
											boxShadow: '5px 5px 30px rgba(3, 98, 175, 0.1)',
											borderRadius: 15,
											marginTop: 20,
											padding: 20,
											backgroundColor: 'white',
										}}>
										<Box display='flex' justifyContent='space-between'>
											<BodyText
												two
												textStyle={{
													fontWeight: 700,
													color: '#00325B',
													opacity: 0.45,
												}}>
												Booking History
											</BodyText>
											<Box display='flex' alignItems='center'>
												<Box
												// onClick={() => {
												// 	history.push('/appointments');
												// 	dispatch(setCurrentMenu('appointments'));
												// 	dispatch(setCurrentSubMenu(''));
												// }}
												>
													<BodyText
														one
														textStyle={{ fontWeight: 600, cursor: 'pointer' }}>
														View All{' '}
														<Divider style={{ backgroundColor: '#00325B' }} />
													</BodyText>
												</Box>
											</Box>
										</Box>
										<TableContainer style={{ marginTop: 15 }}>
											<Table>
												<TableHead>
													<TableRow>
														{tableHeaders.map((title, index) => (
															<StyledTableCell key={title}>
																{title}
															</StyledTableCell>
														))}
													</TableRow>
												</TableHead>
												<TableBody>
													{/* {appnt.map((item, rowIndex) => {
												return (
													<DashboardAppointment item={item} index={rowIndex} />
												);
											})} */}
													{[0, 1, 2, 3, 4, 5].map((i, index) => {
														return <DashboardTable rowIndex={index} />;
													})}
												</TableBody>
											</Table>
										</TableContainer>
									</Grid>
								</Grid>
							</>
						)}
						{data === 'edit' && <MyProfileForm />}
						{data === 'password' && <ChangePasswordForm />}
						{data === 'markup' && <ManageMarkupForm />}
						{data === 'bank' && <BankDetails />}
						{data === 'overview' && <Overview />}
						{/* dd */}
						{/* <Grid container spacing={2}>
							<Grid
								item
								xs={12}
								style={{
									boxShadow: '5px 5px 30px rgba(3, 98, 175, 0.1)',
									borderRadius: 15,
									marginTop: 20,
									padding: 20,
									backgroundColor: 'white',
								}}>
								<Box display='flex' justifyContent='space-between'>
									<BodyText
										two
										textStyle={{
											fontWeight: 700,
											color: '#00325B',
											opacity: 0.45,
										}}>
										Appointment Activity ({appnt.length})
									</BodyText>
									<Box display='flex' alignItems='center'>
										<Box
											onClick={() => {
												history.push('/appointments');
												dispatch(setCurrentMenu('appointments'));
												dispatch(setCurrentSubMenu(''));
											}}>
											<BodyText
												one
												textStyle={{ fontWeight: 600, cursor: 'pointer' }}>
												View All{' '}
												<Divider style={{ backgroundColor: '#00325B' }} />
											</BodyText>
										</Box>
									</Box>
								</Box>
								<TableContainer style={{ marginTop: 15 }}>
									<Table>
										<TableHead>
											<TableRow>
												{tableHeaders.map((title, index) => (
													<StyledTableCell key={title}>{title}</StyledTableCell>
												))}
											</TableRow>
										</TableHead>
										<TableBody>
											{appnt.map((item, rowIndex) => {
												return (
													<DashboardAppointment item={item} index={rowIndex} />
												);
											})}
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>
						</Grid> */}
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default Dashboard;
